import httpService from "../httpService";
import utils from "../utils";

export const vbIncomingDocTdhvpViewService = {
  findAllVbTiepNhan(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbIncomingDocTdhvpView/findAllVbTiepNhan", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/vbIncomingDocTdhvpView/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbIncomingDocTdhvpViewService.js